import { useState } from "react";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { CustomButton } from "ui";
import { returnContractToDraft } from "services";
import { useNotificationContext } from "providers";
import { parseErrorMessage } from "utils";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";

export const ReturnToDraftButton = observer(() => {
  const { contractCard } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const clickHandler = async () => {
    setLoading(true);
    await returnContractToDraft({ id: contractCard.card.id })
      .then(() => {
        openNotification({
          message: "Договор успешно переведен в черновик",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
        setTimeout(() => {
          setLoading(false);
          contractCard.fetchCardById(contractCard.card.id);
          contractCard.history.fetchHistory(contractCard.card.id);
        }, 1500);
      })
      .catch((e) => {
        setLoading(false);
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      });
  };

  return (
    <CustomButton type="default" onClick={clickHandler} tooltip="Откатить договор в статус Черновик" loading={loading}>
      Вернуть в черновик
    </CustomButton>
  );
});
